module.exports = __webpack_public_path__ + "img/16.610c4fec.jpg";